import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsDropdownOpen(false); // Cierra el dropdown después de seleccionar el idioma
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="dropdown ms-3">
      <button
        className="btn btn-outline-secondary dropdown-toggle"
        type="button"
        id="languageDropdown"
        aria-expanded={isDropdownOpen}
        onClick={toggleDropdown}
      >
        <FontAwesomeIcon icon={faGlobe} /> {i18n.language.toUpperCase()}
      </button>
      <ul
        className={`dropdown-menu dropdown-menu-end ${isDropdownOpen ? 'show' : ''}`}
        aria-labelledby="languageDropdown"
      >
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('en')}>
            <img src="https://flagcdn.com/w20/gb.png" alt="English" className="me-2" style={{ width: '20px', height: '14px' }} />
            English
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('es')}>
            <img src="https://flagcdn.com/w20/es.png" alt="Español" className="me-2" style={{ width: '20px', height: '14px' }} />
            Español
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('fr')}>
            <img src="https://flagcdn.com/w20/fr.png" alt="Français" className="me-2" style={{ width: '20px', height: '14px' }} />
            Français
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('it')}>
            <img src="https://flagcdn.com/w20/it.png" alt="Italiano" className="me-2" style={{ width: '20px', height: '14px' }} />
            Italiano
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('pt')}>
            <img src="https://flagcdn.com/w20/pt.png" alt="Português" className="me-2" style={{ width: '20px', height: '14px' }} />
            Português
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('de')}>
            <img src="https://flagcdn.com/w20/de.png" alt="Deutsch" className="me-2" style={{ width: '20px', height: '14px' }} />
            Deutsch
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('zh')}>
            <img src="https://flagcdn.com/w20/cn.png" alt="中文" className="me-2" style={{ width: '20px', height: '14px' }} />
            中文
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('hi')}>
            <img src="https://flagcdn.com/w20/in.png" alt="हिन्दी" className="me-2" style={{ width: '20px', height: '14px' }} />
            हिन्दी
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('ar')}>
            <img src="https://flagcdn.com/w20/sa.png" alt="عربى" className="me-2" style={{ width: '20px', height: '14px' }} />
            عربى
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSelector;
